import { useState, useEffect } from 'react';
import { useSede } from 'context/SedeContext';
import { getAvailabilityByDate, getBookingsByDate, updateAttendance } from '../views/pages/Bookings/service/bookingService';
import { fetchClientById, getBookingsByClient } from '../views/pages/Clients/service/clientsService';
import useSedeRefresh from './useSedeRefresh';
import dayjs from 'dayjs';

export const useClasePorDia = () => {
  const { addSedeHeaders, addSedeParams, getSedeIdsString } = useSede();
  const [date, setDate] = useState(() => dayjs().startOf("day").toDate());
  const [slots, setSlots] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingClients, setLoadingClients] = useState(false);
  const [modalDetalleOpen, setModalDetalleOpen] = useState(false);
  const [alumnoSeleccionado, setAlumnoSeleccionado] = useState(null);
  const [historialCliente, setHistorialCliente] = useState([]);
  const [asistenciaModalOpen, setAsistenciaModalOpen] = useState(false);
  const [reservaSeleccionada, setReservaSeleccionada] = useState(null);

  const storedUser = localStorage.getItem("user");
  const currentUser = storedUser ? JSON.parse(storedUser) : null;
  const isAdmin = currentUser?.groups?.includes("admin");

  const asistenciaDisplay = {
    attended: { label: "Asistió", color: "success" },
    no_show: { label: "No asistió", color: "danger" },
    pending: { label: "Pendiente", color: "warning" }
  };

  const fetchAll = async (retryCount = 0) => {
    if (loading) {
      console.log('⏳ Petición ya en progreso, saltando...');
      return;
    }
    
    setLoading(true);
    const formatted = date.toLocaleDateString('sv-SE');
    const headers = addSedeHeaders();
    const params = addSedeParams();
    
    console.log('🔍 Debug useClasePorDia:', {
      formatted,
      headers,
      params,
      sedeIds: getSedeIdsString ? getSedeIdsString() : 'undefined',
      retryCount
    });
    
    try {
      const disponibilidad = await getAvailabilityByDate(formatted, params, headers);
      const reservas = await getBookingsByDate(formatted, params, headers);
      setSlots(disponibilidad.slots);
      setBookings(reservas);
      console.log('✅ Datos cargados exitosamente');
    } catch (error) {
      console.error('❌ Error en fetchAll:', error);
      
      // Retry logic para Network Errors
      if (error.code === 'ERR_NETWORK' && retryCount < 2) {
        console.log(`🔄 Reintentando... (${retryCount + 1}/2)`);
        setTimeout(() => {
          fetchAll(retryCount + 1);
        }, 1000 * (retryCount + 1)); // Delay incremental
        return;
      }
      
      // Si es un Network Error y ya se agotaron los reintentos
      if (error.code === 'ERR_NETWORK') {
        console.error('❌ Network Error persistente - Posible problema con DevTools');
        console.log('💡 Sugerencia: Cierra DevTools, recarga la página y vuelve a abrir DevTools');
      }
    } finally {
      setLoading(false);
    }
  };

  const openAsistenciaModal = (booking) => {
    setReservaSeleccionada(booking);
    setAsistenciaModalOpen(true);
  };

  const handleConfirmarAsistencia = async (estado) => {
    try {
      setLoading(true);
      await updateAttendance(reservaSeleccionada.id, estado);
      window.toast?.success("Asistencia actualizada.");
      setAsistenciaModalOpen(false);
      fetchAll();
    } catch (err) {
      console.error("Error al actualizar asistencia", err);
      window.toast?.error("No se pudo actualizar la asistencia.");
    } finally {
      setLoading(false);
    }
  };

  const openDetalleModal = async (booking) => {
    if (!booking.client_id) return;

    try {
      setLoading(true);
      const sedeHeaders = addSedeHeaders();
      const sedeParams = addSedeParams();
      
      const fullClient = await fetchClientById(booking.client_id, sedeParams, sedeHeaders);
      const historial = await getBookingsByClient(booking.client_id, sedeParams, sedeHeaders);
      setAlumnoSeleccionado(fullClient);
      setHistorialCliente(historial);
      setModalDetalleOpen(true);
    } catch (err) {
      console.error("Error al obtener datos del cliente:", err);
      window.toast?.error("No se pudo cargar la información del alumno.");
    } finally {
      setLoading(false);
    }
  };

  const openModal = (clase) => {
    setSelectedClass(clase);
    setLoadingClients(true);
    setModalOpen(true);
  };

  const openCancelModal = (booking) => {
    setSelectedBooking(booking);
    setCancelModalOpen(true);
  };

  const getAlumnos = (schedule_id) =>
    bookings.filter(b => b.schedule_id === schedule_id);

  useEffect(() => {
    fetchAll();
  }, [date]);

  return {
    date,
    setDate,
    slots,
    bookings,
    selectedClass,
    modalOpen,
    setModalOpen,
    cancelModalOpen,
    setCancelModalOpen,
    selectedBooking,
    loading,
    loadingClients,
    setLoadingClients,
    modalDetalleOpen,
    setModalDetalleOpen,
    alumnoSeleccionado,
    historialCliente,
    asistenciaModalOpen,
    setAsistenciaModalOpen,
    reservaSeleccionada,
    isAdmin,
    asistenciaDisplay,
    openAsistenciaModal,
    handleConfirmarAsistencia,
    openDetalleModal,
    openModal,
    openCancelModal,
    getAlumnos,
    fetchAll
  };

  // Escuchar cambios de sede y refrescar automáticamente
  useSedeRefresh(fetchAll, [addSedeParams, addSedeHeaders]);
};
